import { DateFormat, ShipmentTabId } from "./types/domain";

export const DEFAULT_TAB_ID: ShipmentTabId = "activity";

export const DateFormats: Record<DateFormat, string> = {
  long: "cccc, MMM dd",
  short: "EEE, MMM dd",
};
